// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2y4Fd","containerItemsCenter":"Skeleton_containerItemsCenter__1i9O8"};